import React from "react";
import { LinkedReferencesCell } from "@adsk/acc-reference-picker";
import { createSimpleCellRenderer } from "./cellRenderers";
import {
  ISSUES_DOMAIN,
  ISSUES_ENTITY_TYPE,
} from "../../../constants/relationships";
import ReferencePickerPlugin from "@adsk/acc-reference-picker/es/types/ReferencePickerPlugin";
import { Issue } from "@adsk/acc-issues-types";

export const referencesCellRenderer = createSimpleCellRenderer(
  ({
    cellData,
    rowData,
  }: {
    cellData: { plugins: ReferencePickerPlugin<Issue>[] };
    rowData: { id: string };
  }) => (
    <LinkedReferencesCell
      sourceEntityType={ISSUES_ENTITY_TYPE}
      sourceEntityDomain={ISSUES_DOMAIN}
      plugins={cellData.plugins}
      sourceEntityId={rowData.id}
    />
  )
);
